import React from 'react';
import PropTypes from 'prop-types';
import clxBind from 'classnames/bind';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Col extends React.Component {
  static propTypes = {
    ratio: PropTypes.shape({
      xs: PropTypes.number,
      sm: PropTypes.number,
      md: PropTypes.number,
      lg: PropTypes.number,
      xl: PropTypes.number,
    }),
    vAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
    hSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    vSpacing: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    ratio: {},
    vAlign: 'top',
    hSpacing: 'md',
    vSpacing: 'md',
    className: undefined,
    children: null,
  };

  static contextTypes = {
    screenSize: PropTypes.string,
  };

  getWidth = () => {
    const { ratio } = this.props;
    const { screenSize } = this.context;

    const lookupSizes = ['xl', 'lg', 'md', 'sm', 'xs'];
    const screenIndex = lookupSizes.indexOf(screenSize);

    const size = lookupSizes.find((s, index) => index >= screenIndex && ratio[s]);

    if (!size) {
      return 100;
    }

    return ratio[size];
  };

  render() {
    const { vAlign, hSpacing, vSpacing, children, className } = this.props;

    const colClasses = clx('col', className, {
      [`v-align-${vAlign}`]: vAlign,
      [`v-spacing-${vSpacing}`]: vSpacing,
      [`h-spacing-${hSpacing}`]: hSpacing,
    });

    return (
      <div className={colClasses} style={{ width: `${this.getWidth()}%` }}>
        {children}
      </div>
    );
  }
}
